import { render, staticRenderFns } from "./DataWorkbench.vue?vue&type=template&id=2f8eb7a6&scoped=true&"
import script from "./DataWorkbench.vue?vue&type=script&lang=js&"
export * from "./DataWorkbench.vue?vue&type=script&lang=js&"
import style0 from "./DataWorkbench.vue?vue&type=style&index=0&id=2f8eb7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8eb7a6",
  null
  
)

export default component.exports